var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"model-wrap"},[_c('modelView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }